import React, { useState, useEffect } from 'react';
import {
    Modal, Form, Input, Select, Button, notification,
} from 'antd';
import { addPlan, updatePlan } from '../../../api/payments';
import { FREQUENCY_OPTIONS } from '../common/constants';

interface PlanEditorModalProps {
  visible: boolean;
  plan: any;
  onClose: (updatedPlan?: any) => void;
}

const PlanEditorModal: React.FC<PlanEditorModalProps> = ({
    visible, plan, onClose,
}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const isEditing = !!plan?._id;

    useEffect(() => {
        if (!plan) return;
        form.setFieldsValue({
            name: plan.name || '',
            frequency: plan.frequency || 'WEEKLY',
        });
    }, [plan, form]);

    const handleSave = async () => {
        try {
            await form.validateFields();
        } catch {
            return;
        }

        setLoading(true);
        const values = form.getFieldsValue();

        try {
            if (isEditing) {
                const { data } = await updatePlan(plan._id, values);
                notification.success({ message: 'Plan actualizado' });
                onClose(data.data || data);
            } else {
                const { data } = await addPlan(values);
                notification.success({ message: 'Plan creado' });
                onClose(data.data || data);
            }
        } catch {
            notification.error({ message: 'Error guardando plan' });
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Modal
            title={isEditing ? `Editar: ${plan?.name}` : 'Crear Plan'}
            open={visible}
            width={500}
            onCancel={handleCancel}
            destroyOnClose
            footer={[
                <Button key="cancel" onClick={handleCancel}>Cancelar</Button>,
                <Button key="save" type="primary" loading={loading} onClick={handleSave}>
                    {isEditing ? 'Actualizar' : 'Crear'}
                </Button>,
            ]}
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{ frequency: 'WEEKLY' }}
            >
                <Form.Item
                    label="Nombre del plan"
                    name="name"
                    rules={[{ required: true, message: 'El nombre es requerido' }]}
                >
                    <Input placeholder="ej: Plan Ecuador - Semanal" />
                </Form.Item>
                <Form.Item
                    label="Frecuencia de cobro"
                    name="frequency"
                    rules={[{ required: true, message: 'La frecuencia es requerida' }]}
                >
                    <Select options={FREQUENCY_OPTIONS} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export { PlanEditorModal };
